import { render, staticRenderFns } from "./WaterfallList.vue?vue&type=template&id=146f42b2"
import script from "./WaterfallList.vue?vue&type=script&lang=ts"
export * from "./WaterfallList.vue?vue&type=script&lang=ts"
import style0 from "./WaterfallList.vue?vue&type=style&index=0&id=146f42b2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports